import { Controller } from "@hotwired/stimulus"

// Anonymisation d'une fiche : le bouton ne s'active qu'une fois le nom de la fiche retapé
// (accents, casse et espaces ignorés, comme la vérification de la command AnonymizePerson).
export default class extends Controller {
  static targets = ["input", "submit"]
  static values = { expected: String }

  connect() { this.check() }

  check() {
    this.submitTarget.disabled = this.normalize(this.inputTarget.value) !== this.normalize(this.expectedValue)
  }

  normalize(value) {
    return (value || "").normalize("NFD").replace(/\p{Mn}/gu, "").toLowerCase().replace(/[^a-z0-9]+/g, " ").trim()
  }
}
